import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, InputGroup, Switch, Tag } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IAgendamento, IEmpresa, newEmpresa, newIAgendamento } from "../../model";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { toast } from "react-toastify";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj, sortBy } from "../../utils";
import MomentLocaleUtils from "react-day-picker/moment";
import SolicitaFgtsDigital from "./SolicitaFgtsDigital";
import { FgtsDigitalStore } from "../../stores/fgts_digital/FgitsDigitalStore";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";

@observer
export default class FgtsDigitalPage extends React.Component<{}, {}> {

  obs = observable({
    tarefas_page: 1 as number,
    selectEmpresa: newEmpresa() as IEmpresa,
    erros: "" as string,
    view_erros: false as boolean,
    open_agendamentos: false as boolean,
    open_create_agendamento: false as boolean,
    agendamento: newIAgendamento() as IAgendamento,
  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
    AppStore.setTitle("FGTS Digital");

    FgtsDigitalStore.obs.tasks_fgts_digital = []

  }

  handleBuscaTarefasPaged = async (page: number) => {

    this.obs.tarefas_page = page

    FgtsDigitalStore.obs.loading_tasks = true

    FgtsDigitalStore.handleTasksPaged(page, this.obs.selectEmpresa.cnpj);

  };

  createCustomSearchField = (props) => {

    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );

  };


  handleBuscaTarefas = async (empresa) => {

    this.obs.selectEmpresa = empresa

    FgtsDigitalStore.obs.loading_tasks = true

    await FgtsDigitalStore.handleTasksPaged(1, this.obs.selectEmpresa.cnpj);

  };

  onCloseErros() {
    this.obs.view_erros = false
    this.obs.erros = ""
  }

  handleAtualizaTarefasPaged = async () => {

    if (this.obs.selectEmpresa.cnpj == "") {
      toast.warning('Selecione uma empresa!', {});
      return;
    }

    FgtsDigitalStore.obs.loading_tasks = true

    await FgtsDigitalStore.handleTasksPaged(this.obs.tarefas_page, this.obs.selectEmpresa.cnpj);

  };

  handleViewDetalhesAgend = async (row: any) => {

    this.obs.open_create_agendamento = true

    this.obs.agendamento.periodo_selecionado = row.recorrente ? row.dia : row.dia_recorrencia
    this.obs.agendamento.listEmpresas = row.empresas || []
    this.obs.agendamento.recorrente = row.recorrente

  };

  handleDeleteAgendamento = async (row: any) => {

    await FgtsDigitalStore.handleDeleteAgendamento(row.id)

  };

  async handleOpenAgendamentos() {

    FgtsDigitalStore.obs.page_agendamentos = 1

    await FgtsDigitalStore.handleIndexAgendamentos(1);

    this.obs.open_agendamentos = true

  }

  async handleCloseAgendamento() {

    this.obs.open_create_agendamento = false

    this.obs.agendamento = newIAgendamento()

  }

  handleFiltraAgendamentos = async () => {

    FgtsDigitalStore.obs.page_agendamentos = 1;

    await FgtsDigitalStore.handleIndexAgendamentos(1);

  };


  handlePageAgendamento = async (page: number) => {

    FgtsDigitalStore.obs.page_agendamentos = page;

    await FgtsDigitalStore.handleIndexAgendamentos(page);

  };

  render() {

    function statusFormatter(cell, row) {

      return getTag(row.status, row.tipo);

    }

    function dateFormatter(cell, row) {

      if (cell) {

        return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " às " + moment(cell).add(3, "hour").format("HH:mm");

      }

      return moment(row.inserted_at).add(3, "hour").format("DD/MM/YYYY") + " às " + moment(row.inserted_at).add(3, "hour").format("HH:mm");

    };

    let select_empresas = EmpresaStore.sortedEmpresas.map(map_emp => {

      let emp = EmpresaStore.getByCnpj(map_emp.cnpj);

      if (emp && emp.ativo && this.obs.agendamento.listEmpresas.includes(emp.cnpj)) {

        return ({
          _id: emp._id,
          razao_social: emp.razao_social,
          apelido: emp.apelido,
          cnpj: formatCnpj(emp.cnpj),
          cnpj_default: emp.cnpj
        })

      } else {

        return null;

      }

    }).filter(x => x != null)

    const btnDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => this.handleViewDetalhesAgend(row)}
          >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>

          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => this.handleDeleteAgendamento(row)}
          >
            <img src="/images/bin.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    let empresaText = this.obs.selectEmpresa.cnpj != ""
      ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
      : "Selecione uma empresa";

    let agendamentos = FgtsDigitalStore.obs.index_agendamentos?.map(values => {

      return ({
        id: (values.id || values._id),
        tipo: values.recorrente ? 'Sim' : 'Não',
        recorrente: values.recorrente,
        dia_recorrencia: `${values.dia}/${values.mes}/${values.ano}`,
        dia: values.dia,
        empresas: values.cnpjs,
        itens: values,
        descricao: values.descricao
      })

    })

    const handleDownloadGuia = async (row: any) => {

      await FgtsDigitalStore.downloadArquivos(row.fgtsdigital_id, this.obs.selectEmpresa.cnpj, "guia");

    };

    const handleDownloadRelatorio = async (row: any) => {

      await FgtsDigitalStore.downloadArquivos(row.fgtsdigital_id, this.obs.selectEmpresa.cnpj, "relatorio");

    };

    const handleViewErros = async (row: any) => {

      this.obs.erros = row.error

      if (row.error != "" && row.error != null) {

        this.obs.view_erros = true

      } else {

        toast.warn("Nenhum erro encontrado!", {});
        return

      }

    }

    function vencimentoFormatter(cell, row) {

      if (cell) {

        return <b>{cell.toUpperCase()}</b>

      }

      return "";

    };

    const viewErros = (cell, row) => {
      return (
        <MDBBtn
          disabled={!row.fgtsdigital_id}
          color="default"
          rounded
          size="sm"
          onClick={(e) => handleViewErros(row)}
        >
          <img src="/images/view.png" width="18px" />
        </MDBBtn>
      );
    }

    const viewGuia = (cell, row) => {
      return (
        <MDBBtn
          disabled={!row.fgtsdigital_id}
          color="default"
          rounded
          size="sm"
          onClick={(e) => handleDownloadGuia(row)}
        >
          <img src="/images/download.svg" width="18px" />
        </MDBBtn>
      );
    }

    const viewRelatorio = (cell, row) => {
      return (
        <MDBBtn
          disabled={!row.fgtsdigital_id}
          color="default"
          rounded
          size="sm"
          onClick={(e) => handleDownloadRelatorio(row)}
        >
          <img src="/images/download.svg" width="18px" />
        </MDBBtn>
      );
    }

    const options = {
      searchField: this.createCustomSearchField,
    };

    return (
      <>
        <MDBRow>

          <MDBCol md="4">
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => this.handleBuscaTarefas(e)}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT} />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={() => this.handleAtualizaTarefasPaged()}
            >
              Buscar
            </MDBBtn>
          </MDBCol>

        </MDBRow>

        <MDBRow>
          <MDBCol md="12" className="">
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={(e) => FgtsDigitalStore.obs.open_solicitar = true}
              style={{ marginRight: 10, float: "right" }}>
              Criar Solicitação
            </MDBBtn>

            <MDBBtn
              className="btnDefault btnBuscarNfe"
              style={{ marginRight: 10, float: "right" }}
              onClick={() => this.handleOpenAgendamentos()}>
              Agendamentos
            </MDBBtn>

          </MDBCol>
        </MDBRow>

        <div>
          <BootstrapTable className="TableDefault" ref="table" data={sortBy(FgtsDigitalStore.obs.tasks_fgts_digital, "inserted_at").reverse()}>
            <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="descricao" width="20%">Descrição</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="10%">Data Solicitação</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormatter} dataField="_modifiedTS" width="10%">Ultima Atualização</TableHeaderColumn>
            <TableHeaderColumn dataFormat={statusFormatter} width="20%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={vencimentoFormatter} dataField="vencimento" width="20%">Vencimento</TableHeaderColumn>
            <TableHeaderColumn dataFormat={viewErros} width="5%">Erros</TableHeaderColumn>
            <TableHeaderColumn dataFormat={viewGuia} width="5%">Guia</TableHeaderColumn>
            <TableHeaderColumn dataFormat={viewRelatorio} width="10%">Detalhamento</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.tarefas_page}
            totalCount={FgtsDigitalStore.obs.tasks_length}
            pageSize={15}
            onPageChange={page => this.handleBuscaTarefasPaged(page)} />
        </div>

        {FgtsDigitalStore.obs.open_solicitar && <SolicitaFgtsDigital />}

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.view_erros}
          onConfirm={() => this.onCloseErros()}
          onClose={() => this.onCloseErros()}
          canOutsideClickCancel={true}
          className="AlertUser"
          intent="primary"
        >
          <h3 className="titleProccess titleCnae">Logs Erros</h3>
          <br />
          <p>{this.obs.erros}</p>
        </Alert>

        <LoadingModal open={FgtsDigitalStore.obs.loading_arquivos} onClose={() => FgtsDigitalStore.obs.loading_arquivos = false} title={"Baixando arquivo"} />
        <LoadingModal open={FgtsDigitalStore.obs.loading_tasks} onClose={() => FgtsDigitalStore.obs.loading_tasks = false} title={"Buscando solicitações"} />

        <Dialog
          isOpen={this.obs.open_agendamentos}
          onClose={() => this.obs.open_agendamentos = false}
          className="AlertUser modal-agendamento"
        >
          <h2 className="titleSEFAZ">Agendamentos</h2>

          <div style={{ display: "flex" }}>
            <FormGroup label="Recorrência" />
            &nbsp;
            &nbsp;
            <Switch
              innerLabelChecked="Sim"
              innerLabel="Não"
              checked={FgtsDigitalStore.obs.agendamentos_filter}
              onChange={(e: any) => {
                FgtsDigitalStore.obs.agendamentos_filter = e.target.checked;
                this.handleFiltraAgendamentos();
              }}
            />
          </div>

          <div style={{ height: 400, overflow: "auto", marginTop: 10 }}>
            <BootstrapTable className="" data={agendamentos}>
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="descricao" width="30%">Descrição</TableHeaderColumn>
              <TableHeaderColumn dataField="tipo" width="10%">Recorrente</TableHeaderColumn>
              <TableHeaderColumn dataField="dia_recorrencia" width="15%">Dia agendamento</TableHeaderColumn>
              <TableHeaderColumn dataFormat={btnDetalhes} width="15%">Detalhes</TableHeaderColumn>
            </BootstrapTable>
          </div>

          <MDBRow>
            <MDBCol md="8" className="page-sefa">
              <div style={{ marginTop: 5 }}>
                <Pager
                  currentPage={FgtsDigitalStore.obs.page_agendamentos}
                  totalCount={FgtsDigitalStore.obs.length_agendamentos}
                  pageSize={5}
                  onPageChange={page => this.handlePageAgendamento(FgtsDigitalStore.obs.page_agendamentos = page)}
                />
              </div>
            </MDBCol>
            <MDBCol md="4">
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_agendamentos = false} style={{ marginTop: "30px", float: "right" }} />
            </MDBCol>
          </MDBRow>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_create_agendamento}
          onClose={() => this.handleCloseAgendamento()}
          className="modal-cnds"
        >

          <h2 className="titleSEFAZ">Visualizar Agendamento</h2>

          <div style={{ display: "flex" }}>
            <FormGroup label="Recorrência" />
            &nbsp;
            &nbsp;
            <Switch
              innerLabelChecked="Sim"
              innerLabel="Não"
              checked={this.obs.agendamento.recorrente}
              disabled
            />
          </div>

          <div style={{ display: "flex" }}>

            <FormGroup className="form-group" label="Descrição" style={{ width: "50%" }}>
              <InputGroup type="text" onChange={(e: any) => this.obs.agendamento.descricao = e.target.value} value={this.obs.agendamento.descricao} disabled />
            </FormGroup>

            &nbsp;

            <FormGroup label={this.obs.agendamento.recorrente ? "Selecione o dia de recorrência" : "Selecione a data"} style={{ width: "50%" }}>
              <InputGroup
                value={this.obs.agendamento.periodo_selecionado}
                disabled
              />
            </FormGroup>

          </div>

          <FormGroup label="Empresas selecionadas:">
            <div className="select-empresa-cnds">
              <BootstrapTable data={select_empresas} options={options} search>
                <TableHeaderColumn dataField="cnpj_default" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="60%">Razão Social</TableHeaderColumn>
                <TableHeaderColumn dataField="cnpj" width="30%">CNPJ</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => this.handleCloseAgendamento()} />
          </div>
        </Dialog>

      </>
    )
  }
}

